import React from 'react';
import './CatalogueBanner.css';
import cataloguePdf from '../Assets/PrimeRehabIndustriesBrochure.pdf';

const CatalogueBanner = () => {
    return (
        <section className="catalogue-banner-section">
            <div className="catalogue-banner-container">
                <div className="catalogue-banner-left">
                    <h1 className="catalogue-title">
                        Physiotherapy that<br />
                        supports your growth
                    </h1>
                    <p className="catalogue-desc">
                        Discover our full range of physiotherapy and rehabilitation equipment designed for clinics, hospitals, and therapy centres.
                    </p>
                    <div className="catalogue-actions">
                        <a href={cataloguePdf} download="PrimeRehabIndustriesBrochure.pdf" className="btn-download" style={{ textDecoration: 'none', display: 'inline-block' }}>Download Catalogue</a>
                    </div>
                </div>

                <div className="catalogue-banner-right">
                    <div className="catalogue-image-wrapper">
                        {/* 
                            Assuming standard Prime Rehab image path for the cover. 
                            If it doesn't match the live server, user will likely provide the exact one. 
                        */}
                        <img
                            src="https://primerehab.ascentbw.com/Image/About/Catalogue.png"
                            alt="Prime Rehab Physiotherapy & Rehabilitation Equipment Catalogue Cover"
                            className="catalogue-cover-img"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CatalogueBanner;
